/*
 * JS del header/megamenu. Extraido de sections/header-custom-megamenu.liquid,
 * donde vivia como <script> inline de 38KB dentro del documento.
 *
 * Motivo: eran 38KB que el navegador tenia que descargar y parsear en CADA
 * pagina, antes de llegar al <img> del banner (el elemento LCP). Como asset
 * externo con defer sale del critical path y ademas se cachea entre paginas.
 *
 * De paso corrige un bug latente: no habia ninguna guarda de re-inicializacion.
 * Cuando el theme editor recargaba la seccion, el script inline se re-ejecutaba
 * y volvia a enganchar los 29 addEventListener sobre el mismo DOM. Ahora se
 * marca el elemento raiz; como una recarga de seccion sustituye ese elemento
 * por uno nuevo sin la marca, la re-inicializacion legitima sigue funcionando
 * y la doble ejecucion sobre el mismo DOM no.
 */
(function () {
  var ROOT_SELECTOR = '.custom-header-megamenu';

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.dataset.megamenuInit === 'true') return;
    root.dataset.megamenuInit = 'true';

    var SECTION_ID = root.dataset.sectionId || '';


      (function() {
        const sectionId = SECTION_ID;
        const MIN_QUERY_LENGTH = 3;
        const wrapper = document.querySelector('[data-search-field]');
        if (!wrapper) return;

        const searchField = wrapper.querySelector('input[type="search"]');
        const container = wrapper.querySelector('[data-predictive-search]');
        if (!searchField || !container) return;

        // ===== SINÓNIMOS CONTEXTUALES MUNDO IN =====
        // Basado en análisis real de 13,192 productos en inventario
        const contextualSynonyms = {
          // HABITACIÓN / RECÁMARA / DORMITORIO (tags: paquete_recamara, recamara)
          'habitacion': ['cama', 'buro', 'ropero', 'cajonera', 'mesa de noche', 'closet'],
          'recamara': ['cama', 'buro', 'ropero', 'cajonera', 'mesa de noche', 'closet'],
          'dormitorio': ['cama', 'buro', 'ropero', 'cajonera', 'mesa de noche', 'closet'],
          'bedroom': ['cama', 'buro', 'ropero', 'cajonera'],
          'cuarto': ['cama', 'buro', 'ropero', 'cajonera'],

          // COMEDOR (103 productos con tag "comedor", 45 con "paquete_comedor")
          'comedor': ['mesa comedor', 'silla comedor', 'banco comedor', 'set comedor', 'paquete comedor'],
          'dining': ['mesa comedor', 'silla comedor', 'banco comedor'],
          'comedores': ['mesa comedor', 'silla comedor', 'set comedor'],

          // COCINA
          'cocina': ['mesa cocina', 'silla cocina', 'banco', 'banqueta'],
          'kitchen': ['mesa', 'silla', 'banco'],

          // SALA / LIVING (16 productos tipo "salas")
          'sala': ['sillon', 'sofa', 'mesa centro', 'librero', 'mueble tv'],
          'living': ['sillon', 'sofa', 'mesa centro', 'librero'],
          'salas': ['sillon', 'sofa', 'mesa centro'],

          // OFICINA (94 productos con tag "oficina", 62 sillas oficina, 47 escritorios, 61 paquete_homeoffice)
          'oficina': ['escritorio', 'silla oficina', 'silla ejecutiva', 'archivero', 'cajonera'],
          'office': ['escritorio', 'silla oficina', 'archivero'],
          'trabajo': ['escritorio', 'silla oficina', 'archivero'],
          'home office': ['escritorio', 'silla oficina', 'archivero'],
          'homeoffice': ['escritorio', 'silla oficina', 'archivero'],

          // EXTERIORES (tag "silla de exterior")
          'exterior': ['silla exterior', 'mesa exterior', 'banco exterior'],
          'jardin': ['silla exterior', 'mesa exterior', 'banco'],
          'terraza': ['silla exterior', 'mesa exterior', 'banco'],
          'patio': ['silla exterior', 'mesa exterior', 'banco'],

          // ALMACENAJE (39 productos con tag "almacenaje")
          'almacenaje': ['archivero', 'cajonera', 'librero', 'organizador'],
          'organizacion': ['archivero', 'cajonera', 'librero', 'organizador'],
          'guardar': ['archivero', 'cajonera', 'librero', 'organizador'],
          'storage': ['archivero', 'cajonera', 'librero'],

          // ESPACIOS GENERALES
          'hogar': ['mesa', 'silla', 'cama', 'sillon'],
          'casa': ['mesa', 'silla', 'cama', 'sillon'],
          'muebles': ['mesa', 'silla', 'escritorio', 'cama']
        };

        // Sinónimos directos basados en productos reales
        const directSynonyms = {
          // SILLAS (67 sillas hogar + 62 sillas oficina = 129 productos)
          'silla': ['chair', 'sillas'],
          'sillas': ['silla', 'chair'],
          'chair': ['silla', 'sillas'],
          'silla comedor': ['silla hogar', 'dining chair'],
          'silla oficina': ['silla ejecutiva', 'office chair', 'silla directiva'],
          'ejecutiva': ['silla oficina', 'silla ejecutiva', 'directiva'],
          'directiva': ['silla oficina', 'silla ejecutiva', 'ejecutiva'],

          // MESAS (44 productos tipo "mesas" + 9 "mesa comedor")
          'mesa': ['table', 'mesas'],
          'mesas': ['mesa', 'table'],
          'table': ['mesa', 'mesas'],
          'mesa comedor': ['dining table', 'mesa hogar'],
          'mesa centro': ['coffee table', 'mesa sala'],
          'mesa trabajo': ['escritorio', 'desk'],

          // ESCRITORIOS (47 productos)
          'escritorio': ['desk', 'escritorios', 'mesa trabajo'],
          'escritorios': ['escritorio', 'desk'],
          'desk': ['escritorio', 'escritorios'],
          'escritorio gamer': ['gaming desk', 'escritorio gaming'],

          // SOFÁS/SILLONES (16 salas, 5 sillón)
          'sofa': ['sillon', 'sofas'],
          'sofas': ['sofa', 'sillon'],
          'sillon': ['sofa', 'sillones'],
          'sillones': ['sillon', 'sofa'],

          // CAMAS
          'cama': ['bed', 'camas'],
          'camas': ['cama', 'bed'],
          'bed': ['cama', 'camas'],

          // BANCOS (25 bancos + 47 sets sillas y bancos)
          'banco': ['stool', 'banqueta', 'bancos'],
          'bancos': ['banco', 'stool'],
          'stool': ['banco', 'banqueta'],
          'banqueta': ['banco', 'stool'],

          // ALMACENAJE (23 hogar + 22 oficina)
          'archivero': ['filing cabinet', 'archivo', 'archiveros'],
          'archiveros': ['archivero', 'archivo'],
          'cajonera': ['drawer', 'cajoneras', 'comoda'],
          'librero': ['bookcase', 'estante', 'libreros'],
          'libreros': ['librero', 'estante'],
          'estante': ['shelf', 'librero', 'estantes'],
          'organizador': ['organizer', 'organizadores'],

          // ROPEROS
          'ropero': ['closet', 'armario', 'roperos'],
          'closet': ['ropero', 'armario'],
          'armario': ['closet', 'ropero'],

          // BURÓS
          'buro': ['nightstand', 'mesa noche', 'buros'],
          'buros': ['buro', 'nightstand'],

          // MUEBLES TV
          'mueble tv': ['tv stand', 'rack tv', 'centro entretenimiento'],
          'rack': ['mueble tv', 'estante'],

          // SETS/PAQUETES (tags comunes: set comedor, paquete_comedor, paquete_homeoffice)
          'set': ['paquete', 'juego', 'combo'],
          'paquete': ['set', 'combo', 'juego'],
          'juego': ['set', 'paquete'],
          'combo': ['set', 'paquete']
        };

        // Términos populares para autocompletado (basado en productos reales)
        const popularSearchTerms = [
          // Habitaciones
          'habitacion', 'recamara', 'dormitorio',
          // Espacios
          'comedor', 'sala', 'oficina', 'cocina', 'exterior', 'jardin',
          // Muebles principales
          'silla', 'silla oficina', 'silla comedor', 'silla ejecutiva',
          'mesa', 'mesa comedor', 'mesa centro',
          'escritorio', 'escritorio gamer', 'escritorio oficina',
          'cama', 'sofa', 'sillon', 'banco',
          // Almacenaje
          'archivero', 'cajonera', 'librero', 'organizador', 'ropero', 'buro',
          // Conjuntos
          'set comedor', 'paquete comedor', 'paquete recamara', 'paquete oficina',
          // Otros
          'mueble tv', 'mesa trabajo', 'home office'
        ];

        // Autocompletado: obtener sugerencias basadas en lo que escribe el usuario
        function getAutocompleteSuggestions(input) {
          if (!input || input.length < 2) return [];

          const lower = input.toLowerCase().trim();
          const normalized = lower.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

          // Buscar coincidencias en términos populares
          const startsWith = [];
          const includes = [];

          popularSearchTerms.forEach(term => {
            const normalizedTerm = term.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            if (normalizedTerm.startsWith(normalized)) {
              startsWith.push(term);
            } else if (normalizedTerm.includes(normalized)) {
              includes.push(term);
            }
          });

          // Priorizar términos que empiezan con la búsqueda
          return [...startsWith, ...includes].slice(0, 5); // Máximo 5 sugerencias
        }

        // Obtener términos de búsqueda basados en contexto
        function getSearchTerms(term) {
          const lower = term.toLowerCase().trim();
          const normalized = lower.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          const words = normalized.split(/\s+/);
          const terms = [];

          // 1. Verificar si es un contexto específico
          if (contextualSynonyms[normalized]) {
            // console.log('🏠 Contexto detectado:', normalized);
            // Retornar solo los 4 términos más relevantes para evitar sobrecarga
            return contextualSynonyms[normalized].slice(0, 4);
          }

          // 2. Verificar cada palabra
          words.forEach(word => {
            if (contextualSynonyms[word]) {
              // console.log('🏠 Contexto en palabra:', word);
              terms.push(...contextualSynonyms[word].slice(0, 3));
            } else if (directSynonyms[word]) {
              terms.push(...directSynonyms[word]);
            }
          });

          // Si encontramos sinónimos, usarlos. Si no, usar el término original
          if (terms.length > 0) {
            return [...new Set(terms)].slice(0, 4);
          }

          return [term];
        }

        const types = ['products', 'pages', 'articles'];
        const lists = {
          products: container.querySelector('[data-predictive-list="products"]'),
          pages: container.querySelector('[data-predictive-list="pages"]'),
          articles: container.querySelector('[data-predictive-list="articles"]'),
        };
        const sections = {
          products: container.querySelector('[data-predictive-section="products"]'),
          pages: container.querySelector('[data-predictive-section="pages"]'),
          articles: container.querySelector('[data-predictive-section="articles"]'),
        };
        const emptyState = container.querySelector('[data-predictive-empty]');
        const emptyParagraph = emptyState ? emptyState.querySelector('p') : null;
        const defaultEmptyMessage = emptyParagraph ? emptyParagraph.textContent : 'No encontramos resultados para tu búsqueda.';
        const errorMessage = 'Ocurrió un error al cargar la búsqueda. Intenta de nuevo.';

        // Referencias para autocompletado
        const autocompleteContainer = container.querySelector('[data-autocomplete-suggestions]');
        const suggestionsList = container.querySelector('[data-suggestions-list]');
        let selectedSuggestionIndex = -1;

        let debounceTimer;
        let controller;
        let lastQuery = '';

        container.dataset.hasResults = container.dataset.hasResults || 'false';
        searchField.setAttribute('aria-expanded', 'false');
        if (!searchField.hasAttribute('aria-controls') && container.id) {
          searchField.setAttribute('aria-controls', container.id);
        }
        container.setAttribute('aria-hidden', 'true');

        const resetLists = () => {
          types.forEach((type) => {
            const list = lists[type];
            const section = sections[type];
            if (list) list.innerHTML = '';
            if (section) section.hidden = true;
          });
        };

        const clearResults = () => {
          resetLists();
          clearSuggestions();
          if (emptyState) {
            emptyState.hidden = true;
            if (emptyParagraph) emptyParagraph.textContent = defaultEmptyMessage;
          }

          // Ocultar botón "Ver todos"
          const viewAllContainer = container.querySelector('[data-view-all-results]');
          if (viewAllContainer) viewAllContainer.hidden = true;

          container.dataset.hasResults = 'false';
        };

        // Funciones de autocompletado
        const renderSuggestions = (suggestions) => {
          if (!suggestionsList || !autocompleteContainer) return;

          suggestionsList.innerHTML = '';
          selectedSuggestionIndex = -1;

          if (suggestions.length === 0) {
            autocompleteContainer.hidden = true;
            return;
          }

          suggestions.forEach((suggestion, index) => {
            const li = document.createElement('li');
            li.className = 'predictive-search__suggestion';
            li.dataset.suggestion = suggestion;
            li.dataset.index = index;
            li.innerHTML = `
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              ${suggestion}
            `;

            li.addEventListener('click', () => {
              searchField.value = suggestion;
              lastQuery = ''; // Forzar nueva búsqueda

              // Actualizar sugerencias basadas en el nuevo valor
              const newSuggestions = getAutocompleteSuggestions(suggestion);
              if (newSuggestions.length > 0) {
                renderSuggestions(newSuggestions);
              } else {
                clearSuggestions();
              }

              // Ejecutar búsqueda de productos
              scheduleFetch(suggestion);
            });

            suggestionsList.appendChild(li);
          });

          autocompleteContainer.hidden = false;
        };

        const clearSuggestions = () => {
          if (autocompleteContainer) autocompleteContainer.hidden = true;
          if (suggestionsList) suggestionsList.innerHTML = '';
          selectedSuggestionIndex = -1;
        };

        const createMobileOverlay = () => {
          let overlay = document.getElementById('search-overlay-' + sectionId);
          if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'search-overlay-' + sectionId;
            overlay.style.cssText = `
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(0,0,0,0.3);
              z-index: 1100;
              display: none;
            `;
            // El overlay va dentro del wrapper, justo antes del dropdown, para
            // que comparta su stacking context: asi .predictive-search
            // (z-index 1200) siempre queda por encima. Cuando vivia en <body>
            // tapaba los resultados en mobile y cada tap caia en el overlay
            // (que solo cierra el dropdown) en vez de en el link.
            container.parentNode.insertBefore(overlay, container);

            // Solo click: cerrar en touchstart ocultaba el overlay antes del
            // click y el tap "atravesaba" hasta el producto de abajo.
            overlay.addEventListener('click', () => {
              toggleContainer(false);
            });
          }
          return overlay;
        };

        const toggleContainer = (open) => {
          if (open) {
            container.hidden = false;
            container.setAttribute('data-open', 'true');
            container.setAttribute('aria-hidden', 'false');
            searchField.setAttribute('aria-expanded', 'true');
          } else {
            container.hidden = true;
            container.removeAttribute('data-open');
            container.setAttribute('aria-hidden', 'true');
            searchField.setAttribute('aria-expanded', 'false');
          }

          if (window.innerWidth <= 960) {
            const overlay = createMobileOverlay();
            if (open && container.dataset.open === 'true') {
              overlay.style.display = 'block';
            } else {
              overlay.style.display = 'none';
            }
          }
        };

        const resolveImage = (resource) => {
          const candidates = [
            resource?.image?.url,
            resource?.image?.src,
            resource?.featured_image?.url,
            resource?.featured_image?.src,
            typeof resource?.featured_image === 'string' ? resource.featured_image : '',
            resource?.featured_media?.preview_image?.src,
            resource?.media?.[0]?.preview_image?.src,
            resource?.media?.[0]?.src,
            resource?.images?.[0]?.url,
            resource?.images?.[0]?.src,
          ];
          return candidates.find((value) => typeof value === 'string' && value.trim().length) || '';
        };

        // Algunos titulos de producto se importaron con el encoding mal
        // (UTF-8 leido como Mac Roman): "Metálico" quedo guardado como
        // "Met√°lico". Revertimos esa doble codificacion al mostrarlos. Solo
        // toca pares que forman un caracter UTF-8 valido de 2 bytes, asi que
        // un titulo correcto no cambia.
        const MAC_ROMAN_HIGH = 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»…\u00a0ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ\uf8ffÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ';
        const MOJIBAKE_LEAD = MAC_ROMAN_HIGH.slice(0x42, 0x60); // bytes C2-DF
        const MOJIBAKE_CONT = MAC_ROMAN_HIGH.slice(0x00, 0x40); // bytes 80-BF
        const fixMojibake = (text) => {
          if (!text) return text;
          let out = '';
          for (let i = 0; i < text.length; i++) {
            const lead = MOJIBAKE_LEAD.indexOf(text[i]);
            const cont = lead === -1 ? -1 : MOJIBAKE_CONT.indexOf(text[i + 1] || '');
            if (lead !== -1 && cont !== -1) {
              out += String.fromCharCode(((lead + 0x02) << 6) | cont);
              i++;
            } else {
              out += text[i];
            }
          }
          return out;
        };

        const buildItem = (resource) => {
          const item = document.createElement('li');
          item.className = 'predictive-search__item';

          const link = document.createElement('a');
          link.className = 'predictive-search__link';
          link.href = resource?.url || '#';

          const thumb = document.createElement('span');
          thumb.className = 'predictive-search__thumb';

          const imageUrl = resolveImage(resource);
          if (imageUrl) {
            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = fixMojibake(resource?.title || '');
            thumb.appendChild(img);
          } else {
            thumb.classList.add('predictive-search__thumb--placeholder');
            const fallback = fixMojibake(resource?.title || resource?.query || '').trim().charAt(0).toUpperCase();
            thumb.textContent = fallback || '#';
          }

          const title = document.createElement('span');
          title.className = 'predictive-search__title';
          title.textContent = fixMojibake(resource?.title || resource?.query || '');

          link.append(thumb, title);
          item.appendChild(link);
          return item;
        };

        const renderResults = (resultsByType, query) => {
          let hasResults = false;

          types.forEach((type) => {
            const list = lists[type];
            const section = sections[type];
            const items = Array.isArray(resultsByType[type]) ? resultsByType[type] : [];

            if (!list || !section) return;

            list.innerHTML = '';

            if (!items.length) {
              section.hidden = true;
              return;
            }

            items.forEach((entry) => {
              list.appendChild(buildItem(entry));
            });

            section.hidden = false;
            hasResults = true;
          });

          container.dataset.hasResults = hasResults ? 'true' : 'false';

          // Mostrar botón "Ver todos los resultados"
          const viewAllContainer = container.querySelector('[data-view-all-results]');
          const viewAllLink = container.querySelector('[data-view-all-link]');

          if (viewAllContainer && viewAllLink && hasResults && query) {
            viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;
            viewAllContainer.hidden = false;
          } else if (viewAllContainer) {
            viewAllContainer.hidden = true;
          }

          if (emptyState) {
            emptyState.hidden = hasResults;
            if (!hasResults && emptyParagraph) {
              emptyParagraph.textContent = defaultEmptyMessage;
            }
          }

          toggleContainer(true);
        };

        const handleError = () => {
          resetLists();
          container.dataset.hasResults = 'false';

          // Ocultar botón "Ver todos"
          const viewAllContainer = container.querySelector('[data-view-all-results]');
          if (viewAllContainer) viewAllContainer.hidden = true;

          if (emptyState) {
            if (emptyParagraph) {
              emptyParagraph.textContent = errorMessage;
            } else {
              emptyState.textContent = errorMessage;
            }
            emptyState.hidden = false;
          }
          toggleContainer(true);
        };

        const fetchPredictiveResults = async (query) => {
          if (controller) controller.abort();
          controller = new AbortController();

          // Obtener términos de búsqueda con sinónimos contextuales
          const searchTerms = getSearchTerms(query);
          // console.log('🔍 Buscando:', searchTerms);

          try {
            // Hacer búsquedas paralelas para cada término
            const promises = searchTerms.map(term =>
              fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,page,article&resources[limit]=10&resources[limit_scope]=each`, {
                signal: controller.signal,
                headers: {
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                }
              })
              .then(res => res.ok ? res.json() : null)
              .catch(() => null)
            );

            const responses = await Promise.all(promises);

            if (searchField.value.trim() !== query) return;

            // Combinar resultados únicos
            const combinedResults = {
              products: [],
              pages: [],
              articles: []
            };

            const seenIds = {
              products: new Set(),
              pages: new Set(),
              articles: new Set()
            };

            responses.forEach(payload => {
              if (!payload?.resources?.results) return;

              const results = payload.resources.results;

              // Agregar productos únicos
              if (Array.isArray(results.products)) {
                results.products.forEach(product => {
                  if (!seenIds.products.has(product.id)) {
                    seenIds.products.add(product.id);
                    combinedResults.products.push(product);
                  }
                });
              }

              // Agregar páginas únicas
              if (Array.isArray(results.pages)) {
                results.pages.forEach(page => {
                  if (!seenIds.pages.has(page.id)) {
                    seenIds.pages.add(page.id);
                    combinedResults.pages.push(page);
                  }
                });
              }

              // Agregar artículos únicos
              if (Array.isArray(results.articles)) {
                results.articles.forEach(article => {
                  if (!seenIds.articles.has(article.id)) {
                    seenIds.articles.add(article.id);
                    combinedResults.articles.push(article);
                  }
                });
              }
            });

            // Limitar resultados para el preview
            combinedResults.products = combinedResults.products.slice(0, 6);
            combinedResults.pages = combinedResults.pages.slice(0, 3);
            combinedResults.articles = combinedResults.articles.slice(0, 3);

            // console.log('✅ Resultados encontrados:', combinedResults.products.length, 'productos');

            renderResults(combinedResults, query);

            if (!combinedResults.products.length && !combinedResults.pages.length && !combinedResults.articles.length && emptyState) {
              emptyState.hidden = false;
              if (emptyParagraph) emptyParagraph.textContent = defaultEmptyMessage;
            }

          } catch (error) {
            if (error.name === 'AbortError') return;
            if (searchField.value.trim() !== query) return;
            handleError();
          }
        };

        const scheduleFetch = (query) => {
          if (debounceTimer) clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            fetchPredictiveResults(query);
          }, 220);
        };

        searchField.addEventListener('input', (event) => {
          const query = event.target.value.trim();

          // Caso 1: Menos de 2 caracteres - limpiar todo
          if (query.length < 2) {
            if (controller) controller.abort();
            clearResults();
            clearSuggestions();
            toggleContainer(false);
            lastQuery = '';
            return;
          }

          // Caso 2: Exactamente 2 caracteres - solo mostrar sugerencias
          if (query.length === 2) {
            if (controller) controller.abort();
            clearResults(); // Limpiar resultados previos
            const suggestions = getAutocompleteSuggestions(query);
            renderSuggestions(suggestions);

            if (suggestions.length > 0) {
              toggleContainer(true);
            } else {
              toggleContainer(false);
            }
            lastQuery = '';
            return;
          }

          // Caso 3: 3+ caracteres - mostrar sugerencias + hacer búsqueda completa
          if (query.length >= MIN_QUERY_LENGTH) {
            if (query === lastQuery) return;

            lastQuery = query;

            // Mostrar sugerencias si hay coincidencias
            const suggestions = getAutocompleteSuggestions(query);
            if (suggestions.length > 0) {
              renderSuggestions(suggestions);
            } else {
              clearSuggestions();
            }

            scheduleFetch(query);
          }
        });

        searchField.addEventListener('focus', () => {
          const query = searchField.value.trim();
          if (query.length >= MIN_QUERY_LENGTH && container.dataset.hasResults === 'true') {
            toggleContainer(true);
          }
        });

        wrapper.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            toggleContainer(false);
            searchField.focus();
          }
        });

        document.addEventListener('click', (event) => {
          if (!wrapper.contains(event.target)) {
            toggleContainer(false);
          }
        });

        document.addEventListener('touchstart', (event) => {
          if (!wrapper.contains(event.target)) {
            toggleContainer(false);
          }
        });

        // Search on Enter or click SVG
        const performSearch = () => {
          const q = searchField.value.trim();
          if (!q) return;
          const query = encodeURIComponent(q);
          const url = `/search?q=${query}`;
          window.location.assign(url);
        };

        searchField.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') performSearch();
        });

        const searchIcon = wrapper.querySelector('.search-field svg');
        if (searchIcon) {
          searchIcon.addEventListener('click', performSearch);
        }
      })();

      // Desktop menu hover interactions
      (function() {
        const nav = document.querySelector('.custom-nav-megamenu');
        if (!nav) return;

        const desktopBreakpoint = 960;
        const topDetails = Array.from(nav.querySelectorAll(':scope > ul > li > details[data-navmenu-details]'));
        const timers = new WeakMap();

        const clearTimer = (detail) => {
          const existing = timers.get(detail);
          if (existing) {
            clearTimeout(existing);
            timers.delete(detail);
          }
        };

        const closeDetail = (detail) => {
          clearTimer(detail);
          detail.removeAttribute('open');
        };

        const closeSiblings = (detail) => {
          topDetails.forEach((other) => {
            if (other !== detail) closeDetail(other);
          });
        };

        const scheduleClose = (detail) => {
          clearTimer(detail);
          const timer = setTimeout(() => closeDetail(detail), 300);
          timers.set(detail, timer);
        };

        const handleOpen = (detail) => {
          closeSiblings(detail);
          detail.setAttribute('open', '');
          clearTimer(detail);
        };

        topDetails.forEach((detail) => {
          const summary = detail.querySelector('summary');

          detail.addEventListener('mouseenter', () => {
            if (window.innerWidth <= desktopBreakpoint) return;
            handleOpen(detail);
          });

          detail.addEventListener('mouseleave', () => {
            if (window.innerWidth <= desktopBreakpoint) return;
            scheduleClose(detail);
          });

          detail.addEventListener('focusin', () => {
            if (window.innerWidth <= desktopBreakpoint) return;
            handleOpen(detail);
          });

          detail.addEventListener('focusout', (event) => {
            if (window.innerWidth <= desktopBreakpoint) return;
            if (!detail.contains(event.relatedTarget)) {
              scheduleClose(detail);
            }
          });

          if (summary) {
            summary.addEventListener('click', (event) => {
              if (window.innerWidth <= desktopBreakpoint) return;

              event.preventDefault();

              const href = summary.getAttribute('data-href');
              if (detail.hasAttribute('open')) {
                if (href && href !== '#') {
                  window.location.href = href;
                } else {
                  closeDetail(detail);
                }
              } else {
                handleOpen(detail);
              }
            });
          }
        });

        window.addEventListener('resize', () => {
          if (window.innerWidth > desktopBreakpoint) return;
          topDetails.forEach((detail) => closeDetail(detail));
        });

        // Hover interactions for second and third level menus
        const allDetails = nav.querySelectorAll('details[data-navmenu-details]');
        allDetails.forEach((detail) => {
          const isTopLevel = topDetails.includes(detail);
          if (isTopLevel) return; // Already handled above

          const parentLi = detail.closest('li');
          const summary = detail.querySelector('summary');

          // Mark as hover-controlled
          detail.dataset.hoverControlled = 'true';

          detail.addEventListener('mouseenter', () => {
            if (window.innerWidth <= desktopBreakpoint) return;

            // Cancel any pending close timer
            if (detail.dataset.closeTimer) {
              clearTimeout(detail.dataset.closeTimer);
              delete detail.dataset.closeTimer;
            }

            // Close sibling submenus at the same level to prevent overlap
            const siblings = parentLi.parentElement.querySelectorAll(':scope > li > details[data-navmenu-details]');
            siblings.forEach((sibling) => {
              if (sibling !== detail) {
                sibling.removeAttribute('open');
                // Close all nested menus too
                const nestedDetails = sibling.querySelectorAll('details[data-navmenu-details]');
                nestedDetails.forEach(nested => nested.removeAttribute('open'));
              }
            });

            detail.setAttribute('open', '');
          });

          detail.addEventListener('mouseleave', () => {
            if (window.innerWidth <= desktopBreakpoint) return;
            const timer = setTimeout(() => {
              detail.removeAttribute('open');
              // Close all nested menus
              const nestedDetails = detail.querySelectorAll('details[data-navmenu-details]');
              nestedDetails.forEach(nested => nested.removeAttribute('open'));
            }, 300);
            detail.dataset.closeTimer = timer;
          });

          // Prevent ALL click/toggle behavior on desktop - use capture phase
          detail.addEventListener('toggle', (event) => {
            if (window.innerWidth <= desktopBreakpoint) return;
            if (detail.dataset.hoverControlled === 'true') {
              // If we didn't set it via hover, prevent it
              if (!detail.dataset.allowToggle) {
                event.preventDefault();
                event.stopImmediatePropagation();
              }
              delete detail.dataset.allowToggle;
            }
          }, true);

          if (summary) {
            // Prevent default click behavior on desktop for levels 2 and 3
            summary.addEventListener('click', (event) => {
              if (window.innerWidth <= desktopBreakpoint) return;

              // Always prevent default to disable click-to-open
              event.preventDefault();
              event.stopPropagation();

              // Only navigate if already open and has valid href
              const href = summary.getAttribute('data-href');
              if (detail.hasAttribute('open') && href && href !== '#') {
                window.location.href = href;
              }
            }, true);

            // Prevent toggle behavior on summary click
            summary.addEventListener('mousedown', (event) => {
              if (window.innerWidth <= desktopBreakpoint) return;
              event.preventDefault();
            }, true);
          }
        });
      })();

      // Handle data-href clicks on summary elements (mobile only for submenus)
      (function() {
        const summariesWithHref = document.querySelectorAll('summary[data-href]');

        summariesWithHref.forEach(summary => {
          summary.addEventListener('click', (event) => {
            const href = summary.getAttribute('data-href');
            const details = summary.closest('details');
            const nav = summary.closest('.custom-nav-megamenu');

            // Only handle mobile OR top-level items
            if (window.innerWidth > 960) {
              // On desktop, only handle if it's a top-level item
              const isTopLevel = nav && details && details.parentElement.closest('ul').classList.contains('nav-menu');
              if (!isTopLevel) {
                return; // Let the hover handler deal with it
              }
            }

            // Mobile or top-level navigation
            if (href && href !== '#') {
              if (window.innerWidth > 960) {
                if (details && !details.hasAttribute('open')) {
                  return;
                }
                window.location.href = href;
              } else {
                window.location.href = href;
              }
            }
          });
        });
      })();

      // Mobile sidebar
      (function() {
        const sectionId = SECTION_ID;
        const openButton = document.querySelector('.menu-toggle');
        const sidebar = document.getElementById('mobile-sidebar-' + sectionId);
        const overlay = document.getElementById('mobile-sidebar-overlay-' + sectionId);

        if (!openButton || !sidebar || !overlay) {
          return;
        }

        const closeButton = sidebar.querySelector('.mobile-sidebar__close');

        const openSidebar = () => {
          sidebar.dataset.open = 'true';
          sidebar.setAttribute('aria-hidden', 'false');
          overlay.dataset.open = 'true';
          overlay.setAttribute('aria-hidden', 'false');
          document.body.classList.add('sidebar-open');
        };

        const closeSidebar = () => {
          sidebar.dataset.open = 'false';
          sidebar.setAttribute('aria-hidden', 'true');
          overlay.dataset.open = 'false';
          overlay.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('sidebar-open');
        };

        openButton.addEventListener('click', openSidebar);

        if (closeButton) {
          closeButton.addEventListener('click', closeSidebar);
        }

        overlay.addEventListener('click', closeSidebar);

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && sidebar.dataset.open === 'true') {
            closeSidebar();
          }
        });
      })();

      /**
       * SOLUCIÓN AL PROBLEMA: Header desaparece al agregar productos al carrito
       *
       * PROBLEMA IDENTIFICADO:
       * 1. Al hacer scroll hacia abajo, el header obtiene la clase 'scrolled'
       * 2. Al agregar un producto al carrito, el scroll cambia temporalmente (ej: de 809px a 575px)
       * 3. Esto causa que handleScroll() quite la clase 'scrolled'
       * 4. El header desaparece momentáneamente
       * 5. Al abrir el cart drawer, el dialog fija el body (position: fixed) con top negativo
       * 6. Esto hace que window.scrollY cambie a 0 temporalmente
       * 7. handleScroll() se ejecuta y quita la clase 'scrolled' porque scrollY < 50
       *
       * SOLUCIÓN IMPLEMENTADA:
       * 1. Detectar cuando se agrega algo al carrito (evento 'cart:update')
       * 2. Congelar el estado del header por 1 segundo (freezeHeaderState = true)
       * 3. Bloquear handleScroll() mientras está congelado
       * 4. Usar MutationObserver para restaurar automáticamente la clase 'scrolled' si se quita
       * 5. Detectar cuando se abre el drawer (interceptando open() y showDialog())
       * 6. Guardar el estado del header antes de abrir (headerHadScrolledBeforeDialog)
       * 7. Mantener la protección activa mientras el dialog está abierto y 350ms después de cerrar
       *
       * EVENTOS CLAVE:
       * - cart:update: Se dispara al agregar producto al carrito
       * - dialog:open/close: Se disparan al abrir/cerrar el cart drawer
       *
       * VARIABLES DE ESTADO:
       * - freezeHeaderState: Congela handleScroll por 1 seg después de cart:update
       * - headerHadScrolledBeforeDialog: Guarda si el header tenía scrolled antes de abrir drawer
       */
      document.addEventListener('DOMContentLoaded', function() {
        const header = document.querySelector('header.custom-header-megamenu');
        if (!header) return;

        const headerGroup = document.getElementById('header-group');
        const searchElement = header.querySelector('.search');
        let headerHeight = 0;
        let lastScroll = 0;
        let headerHadScrolledBeforeDialog = false;
        let freezeHeaderState = false;

        // Interceptar métodos del cart-drawer para detectar cuando se abre/cierra
        customElements.whenDefined('cart-drawer-component').then(() => {
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (!cartDrawer) return;

          // Interceptar open() - se llama al hacer clic en el ícono del carrito
          if (cartDrawer.open) {
            const originalOpen = cartDrawer.open.bind(cartDrawer);
            cartDrawer.open = function() {
              if (!headerHadScrolledBeforeDialog) {
                headerHadScrolledBeforeDialog = header.classList.contains('scrolled');
              }
              return originalOpen();
            };
          }

          // Interceptar showDialog() - se llama internamente por open()
          if (cartDrawer.showDialog) {
            const originalShowDialog = cartDrawer.showDialog.bind(cartDrawer);
            cartDrawer.showDialog = function() {
              if (!headerHadScrolledBeforeDialog) {
                headerHadScrolledBeforeDialog = header.classList.contains('scrolled');
              }
              return originalShowDialog();
            };
          }

          // Interceptar close() - se llama al cerrar el drawer
          if (cartDrawer.close) {
            const originalClose = cartDrawer.close.bind(cartDrawer);
            cartDrawer.close = function() {
              const result = originalClose();
              setTimeout(function() {
                headerHadScrolledBeforeDialog = false;
              }, 350);
              return result;
            };
          }

          // Interceptar closeDialog() - se llama internamente por close()
          if (cartDrawer.closeDialog) {
            const originalCloseDialog = cartDrawer.closeDialog.bind(cartDrawer);
            cartDrawer.closeDialog = function() {
              const result = originalCloseDialog();
              setTimeout(function() {
                headerHadScrolledBeforeDialog = false;
              }, 350);
              return result;
            };
          }
        });

        function handleScroll() {
          // Bloquear handleScroll si:
          // 1. El estado está congelado por cart:update (freezeHeaderState)
          // 2. El drawer está abierto o cerrándose (headerHadScrolledBeforeDialog)
          if (freezeHeaderState || headerHadScrolledBeforeDialog) {
            return;
          }

          const currentScroll = window.pageYOffset || window.scrollY;
          const isMobile = window.innerWidth <= 640;

          if (currentScroll > 50) {
            if (!header.classList.contains('scrolled')) {
              headerHeight = header.offsetHeight;
              header.classList.add('scrolled');
              if (headerGroup) {
                headerGroup.style.paddingBottom = headerHeight + 'px';
              }
            }

            // Mobile: ocultar/mostrar búsqueda según dirección de scroll
            if (isMobile && searchElement) {
              if (currentScroll > lastScroll && currentScroll > 100) {
                header.classList.add('hide-search');
              } else if (currentScroll < lastScroll) {
                header.classList.remove('hide-search');
              }
            }
          } else {
            // Solo quitar scrolled si el body no está fixed (no hay dialog abierto)
            if (document.body.style.position !== 'fixed') {
              header.classList.remove('scrolled');
              header.classList.remove('hide-search');
              if (headerGroup) {
                headerGroup.style.paddingBottom = '0';
              }
            }
          }

          lastScroll = currentScroll;
        }

        // MutationObserver para proteger la clase 'scrolled' durante cart:update y dialogs
        // Restaura automáticamente la clase si algo intenta quitarla mientras está protegida
        const headerObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const hasScrolled = header.classList.contains('scrolled');
              const currentScroll = window.scrollY;

              // Restaurar la clase 'scrolled' si:
              // 1. El header tenía scrolled antes de abrir el drawer (headerHadScrolledBeforeDialog)
              // 2. O el estado está congelado por cart:update (freezeHeaderState) y scroll > 50
              if (!hasScrolled && (headerHadScrolledBeforeDialog || (freezeHeaderState && currentScroll > 50))) {
                headerObserver.disconnect();
                header.classList.add('scrolled');
                if (headerGroup) {
                  if (headerHeight === 0) {
                    headerHeight = header.offsetHeight;
                  }
                  headerGroup.style.paddingBottom = headerHeight + 'px';
                }
                headerObserver.observe(header, {
                  attributes: true,
                  attributeFilter: ['class']
                });
              }
            }
          });
        });

        headerObserver.observe(header, {
          attributes: true,
          attributeFilter: ['class']
        });

        // Congelar el estado del header cuando se agrega algo al carrito
        // Esto previene que handleScroll quite la clase 'scrolled' durante el cambio temporal de scroll
        document.addEventListener('cart:update', function() {
          freezeHeaderState = true;
          setTimeout(function() {
            freezeHeaderState = false;
          }, 1000); // 1 segundo de protección
        });

        window.addEventListener('scroll', handleScroll);
        handleScroll();
      });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // El theme editor sustituye el DOM de la seccion al recargarla.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(ROOT_SELECTOR)) init();
  });
})();
